<div class="container" id="servicemaindiv">
  <div class="header-row">
    <div class="button-group">
      <button mat-button (click)="openAddUpdateStatusTypeModal()">Add Status</button>
    </div>
  </div>
  <div class="table-container">
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="statusName">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Status Name
        </mat-header-cell>
        <mat-cell *matCellDef="let item" [ngStyle]="{'color': item.statusColorCode}">
          {{item.statusName}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="statusPrecedence">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Precedence
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.statusPrecedence}}
        </mat-cell>
      </ng-container>
      <ng-container></ng-container>

      <ng-container matColumnDef="statusMessage">
        <mat-header-cell *matHeaderCellDef>
          Message
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.statusMessage}}
        </mat-cell>
      </ng-container>
      <ng-container></ng-container>

      <ng-container matColumnDef="showServiceList">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          Show Outage Services
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.showServiceList ? 'Yes' : 'No'}}
        </mat-cell>
      </ng-container>
      <ng-container></ng-container>

      <ng-container matColumnDef="statusColorCode">
        <mat-header-cell *matHeaderCellDef>
          Color Code
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.statusColorCode | uppercase}}
        </mat-cell>
      </ng-container>
      <ng-container></ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
          Action
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div class="button-group action-buttons">
            <button mat-button (click)="openAddUpdateStatusTypeModal(item)">Edit</button>
            <button mat-button (click)="openConfirmationDialog(item)">Delete</button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
  @if (inprogress) {
    <div class="loading-overlay">
      <mat-spinner color="primary" diameter="48"></mat-spinner>
    </div>
  }
</div>